import COLOR from '@Src/commons/Colors';
import { NormalText, StyledText } from '@Src/commons/StyledComponent';
import PersonComponent from '@smartpaddle/biz-bamboo-v2.ui.person-component';
import { Col, Row, List, Button, Alert, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import {
  CheckmarkCircle20Regular,
  Desktop20Regular,
  Phone20Regular,
  PhoneDesktop16Regular,
  PhoneDesktop20Regular,
} from '@fluentui/react-icons';
import {
  fetchSessions,
  logoutSessions,
  terminateSessions,
} from '@Src/apiServices/authService';
import { useHistory } from 'react-router-dom';
import { showSuccessNotficiation } from '@Src/commons/Notification/ToastNotification';
import { logoutAction } from '@Src/store/reducers/authSlice';

export default function ComponentDevices(props: any) {
  const history = useHistory();
  const { retData, limitBanner } = props;
  const [listOfSessions, setListOfSessions] = useState(retData);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setListOfSessions(retData);
  }, [retData]);

  function iconSelector(parsedUserAgent: { os: string; device: string }) {
    const osLower = parsedUserAgent.os?.toLowerCase() ?? '';
    const deviceLower = parsedUserAgent.device?.toLowerCase() ?? '';

    if (
      osLower.includes('mac') ||
      osLower.includes('windows') ||
      osLower.includes('linux') ||
      deviceLower.includes('mac') ||
      deviceLower.includes('windows') ||
      deviceLower.includes('linux')
    ) {
      return (
        <Desktop20Regular
          style={{ margin: '6px -4px 6px 6px', color: '#343B48' }}
        />
      );
    }
    if (
      osLower.includes('iphone') ||
      osLower.includes('android') ||
      osLower.includes('dart') ||
      deviceLower.includes('iphone') ||
      deviceLower.includes('android') ||
      deviceLower.includes('dart')
    ) {
      return (
        <Phone20Regular
          style={{ margin: '6px -4px 6px 6px', color: '#343B48' }}
        />
      );
    }
    return (
      <PhoneDesktop20Regular
        style={{ margin: '6px -4px 6px 6px', color: '#343B48' }}
      />
    );
  }
  const [api, contextHolder] = notification.useNotification();

  function DeviceList() {
    return (
      <List
        itemLayout="horizontal"
        dataSource={listOfSessions.activeSessions}
        renderItem={(item) => (
          <List.Item
            style={{
              border: `1px solid ${COLOR.GRAY_5}`,
              padding: '8px',
              marginBottom: '16px',
              borderRadius: '8px',
            }}
            actions={[
              <Button
                type="link"
                style={{ marginBottom: '16px' }}
                key="logout"
                disabled={loading}
                onClick={() => {
                  setLoading(true);
                  if (listOfSessions.sessionsAvailable && item.currentSession) {
                    logoutAction()
                      .then((res) => {
                        showSuccessNotficiation(
                          `The Device '${
                            item?.parsedUserAgent?.device ?? 'Other'
                          }' is now logged out`
                        );
                      })
                      .finally(() => {
                        setLoading(false);
                      });
                  } else if (listOfSessions.sessionsAvailable) {
                    logoutSessions(item.sessionId)
                      .then(() => {
                        setLoading(false);

                        fetchSessions().then((res) => {
                          setListOfSessions({
                            activeSessions: res.data,
                            sessionsAvailable: true,
                          });
                        });
                        showSuccessNotficiation(
                          `The Device '${
                            item?.parsedUserAgent?.device ?? 'Other'
                          }' is now logged out`
                        );
                      })
                      .catch((err) => {
                        setLoading(false);
                        console.log('Error during call for logout');
                      });
                  } else {
                    terminateSessions(
                      item.sessionId,
                      listOfSessions.encryptedToken
                    )
                      .then(() => {
                        showSuccessNotficiation(
                          `The Device '${
                            item?.parsedUserAgent?.device ?? 'Other'
                          }' is now logged out`
                        );
                        setLoading(false);
                        history.push('/auth/login');
                      })
                      .catch(() => {
                        setLoading(false);
                        console.log('Error during call for logout');
                      });
                  }
                }}
              >
                Log Out
              </Button>,
            ]}
          >
            <List.Item.Meta
              avatar={iconSelector(
                item?.parsedUserAgent ?? { os: '', device: '' }
              )}
              title={
                <NormalText
                  fontWeight={500}
                  color={COLOR.DARK_BLUE}
                  fontSize={14}
                >
                  {item?.parsedUserAgent?.os?.toLowerCase() === 'ios' ||
                  item?.parsedUserAgent?.os?.toLowerCase() === 'android'
                    ? item?.userAgent
                    : item?.parsedUserAgent?.browser ?? 'Other'}
                  {item?.currentSession && (
                    <span
                      style={{
                        backgroundColor: '#F7F8FB',
                        padding: '1px 8px',
                        fontSize: '12px',
                        color: '#3D4961',
                        borderRadius: '8px',
                        marginLeft: '4px',
                        border: '1px solid #D8DDE6',
                      }}
                    >
                      Current Device
                    </span>
                  )}
                </NormalText>
              }
              description={
                <NormalText fontSize={12} fontWeight={500} color={COLOR.GRAY_8}>
                  {item?.parsedUserAgent?.os?.toLowerCase() === 'ios' ||
                  item?.parsedUserAgent?.os?.toLowerCase() === 'android'
                    ? ''
                    : item?.parsedUserAgent?.device ?? 'Other'}
                  {item.currentSession
                    ? ` • Active Now`
                    : ` • Last Active ${item.lastSignInTime} `}
                </NormalText>
              }
            />
          </List.Item>
        )}
      />
    );
  }
  return (
    <div className="biz-page">
      {contextHolder}
      <Row>
        <Col xs={16}>
          <div className="biz-page-primary-container">
            <div className="biz-page-primary-container-header">
              {!limitBanner && (
                <NormalText fontWeight={600} fontSize={20} color={COLOR.GRAY_9}>
                  Device Management
                </NormalText>
              )}
            </div>
            <div className="biz-page-primary-container-content">
              {limitBanner && (
                <Alert
                  style={{ borderRadius: '8px', background: '#EDF5FF' }}
                  message={
                    <NormalText fontSize={14} fontWeight={500} color="#343B48">
                      Max Device Limit Reached
                    </NormalText>
                  }
                  description={
                    <NormalText
                      color={COLOR.GREY_8}
                      fontSize={12}
                      fontWeight={500}
                    >
                      You've reached your maximum device limit. Please log out
                      from one of the devices below to add a new one.
                    </NormalText>
                  }
                  type="info"
                  icon={
                    <PhoneDesktop20Regular
                      style={{
                        marginLeft: '-10px',
                        marginRight: '13px',
                        color: '#0043CE',
                      }}
                    />
                  }
                  showIcon
                />
              )}
              <DeviceList />
            </div>
          </div>
        </Col>
        <Col xs={8} />
      </Row>
    </div>
  );
}
